// app/shared/components/ServerStatusIndicator.tsx
"use client";

import { useCallback, useSyncExternalStore } from "react";

import { serverHealthMonitor } from "../utils/server-health";

/**
 * Global server status indicator that appears when the backend is unreachable
 */
export function ServerStatusIndicator() {
  const subscribe = useCallback(
    (onStoreChange: () => void) => serverHealthMonitor.subscribe(onStoreChange),
    [],
  );
  const status = useSyncExternalStore(
    subscribe,
    () => serverHealthMonitor.getStatus(),
    () => "healthy" as const,
  );
  const isServerDown = status === "unhealthy";

  if (!isServerDown) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-red-600 text-white px-4 py-3 shadow-lg">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="flex-shrink-0">
            <svg
              className="w-6 h-6 animate-pulse"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <div>
            <p className="font-semibold text-sm">Server Connection Lost</p>
            <p className="text-xs opacity-90">
              Unable to reach the backend. Please check that the server is
              running.
            </p>
          </div>
        </div>
        <button
          onClick={() => {
            void serverHealthMonitor.isHealthy();
          }}
          className="px-4 py-2 bg-white text-red-600 rounded-md text-sm font-medium hover:bg-red-50 transition-colors"
        >
          Retry
        </button>
      </div>
    </div>
  );
}
